import { logger } from '@damofire/data-commons';
import { Remote, wrap } from 'comlink';
import { Observer, Subject } from 'rxjs';
import { WarehouseSyncStepContextEvent, WarehouseSyncStepTask, WarehouseSyncStepTaskContext } from '../executors';
import { WarehouseAssetsStepsWorker } from '../workers/assets.steps.worker';
import { executeWorker, WarehouseSyncStepWorkerFactory } from './steps-utils';

class WarehouseAssetsSyncWorkerFactory implements WarehouseSyncStepWorkerFactory<WarehouseAssetsStepsWorker> {
  async createWorker(environment: any): Promise<[Worker, WarehouseAssetsStepsWorker | Remote<WarehouseAssetsStepsWorker>]> {
    if (environment.appConfig.watson.useWebworkers) {
      const warehouseWorker = new Worker(new URL('../workers/assets.steps.worker', import.meta.url), { type: 'module' });
      const warehouseWorkerProxy = wrap<typeof WarehouseAssetsStepsWorker>(warehouseWorker);
      const workerService = await new warehouseWorkerProxy();
      return [warehouseWorker, workerService];
    }

    return [null, new WarehouseAssetsStepsWorker()];
  }
}

export class WarehousePushAssetsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `PUSH_ASS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing push assets sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseAssetsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseDownloadAssetsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `DOWN_ASS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing download assets sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseAssetsSyncWorkerFactory(), taskBreaker);
  }
}

export class WarehouseCleanAssetsSyncStepTask implements WarehouseSyncStepTask {
  constructor(private readonly environment: any) {}

  name(): string {
    return `CLEAN_ASS_TASK`;
  }

  async execute(ctx: WarehouseSyncStepTaskContext, listener: Observer<WarehouseSyncStepContextEvent>, taskBreaker: Subject<boolean>): Promise<void> {
    logger.debug('Executing clean assets sync task.');
    await executeWorker(ctx, this.environment, listener, new WarehouseAssetsSyncWorkerFactory(), taskBreaker);
  }
}
